module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3547fa1f2678a483a19f46852f36b426.svg";